import { common_urls, common_urls_cws2 } from 'src/environments/environment';

export const FIRST_NAME_CHANGE_BASE_ROUTE = 'first-name-change';

export const FIRST_NAME_CHANGE_STEPPER_TRANSLATION_PREFIX = 'firstNameChange.stepper.';
export const FIRST_NAME_CHANGE_SCREEN_TYPE = FIRST_NAME_CHANGE_BASE_ROUTE;

export const FIRST_NAME_CHANGE_STEP_NAMES = ['step1', 'step2'] as const;

export const FIRST_NAME_CHANGE_ROUTES = {
  DETAILS: 'details',
  CONFIRMATION: 'confirmation',
  COMPLETION: 'completion',
} as const;

export const FIRST_NAME_CHANGE_STEP_INDEX = {
  DETAILS: 0,
  CONFIRMATION: 1,
} as const;

export const FIRST_NAME_CHANGE_API_URLS = {
  LOAD_FIRST_NAME_CHANGE: `${common_urls_cws2.bffBaseUrl_mvp3}/load/owner-name-change`,
  SUBMIT_FIRST_NAME_CHANGE: `${common_urls_cws2.bffBaseUrl_mvp3}/submit/owner-name-change`,
  CWS_HOME: `${common_urls.cwsBaseUrl}/home?From=auth&cws=1`,
   CWS_EMAIL_ENQUIRY: `${common_urls.cwsBaseUrl}/emailinquiry?From=home`,
} as const;
